module.exports = __webpack_public_path__ + "img/logo_espaco.318451b9.svg";